import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../../common/hooks/hooks";
import { openGlobalModal } from "../../../../common/features/globalModal/globalModalSlice";

interface OpenStockNotificationProps {
  productId: number;
  variationId?: number; // Optional
  productName: string;
}

/**
 * A custom hook that returns a function to open the Stock Notification modal.
 * Encapsulates the dispatch logic and title translation.
 */
export const useOpenStockNotificationModal = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const openModal = useCallback(
    ({ productId, variationId, productName }: OpenStockNotificationProps) => {
      dispatch(
        openGlobalModal({
          contentKey: "stockNotification",
          title: t("stockNotification.modalTitle", "Notify me when in stock"),
          contentProps: {
            productId,
            variationId,
            productName,
          },
        })
      );
    },
    [dispatch, t]
  );

  return openModal;
};
